import { IStyle, Theme } from '@fluentui/react';

export const buttonGroupStyles = (theme: Theme): Record<string, IStyle> => ({
  buttonGroupRoot: {
    maxWidth: '85%',
    minWidth: '190px',
    borderRadius: theme.effects.roundedCorner6,
    boxShadow: theme.effects.elevation8,
  },
  list: {
    textAlign: 'center',
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    backgroundColor: theme.palette.neutralPrimary,
    borderRadius: theme.effects.roundedCorner6,
    li: {
      padding: '12px 16px',
      borderBottom: `1px solid ${theme.palette.neutralTertiary}`,
    },
    'li:last-child': {
      borderBottom: 'none',
    },
  },
  button: {
    padding: 5,
    color: theme.palette.white,
    ':hover': {
      background: theme.palette.themePrimary,
      cursor: 'pointer',
      color: 'black'
    },
    ':first-child': {
      borderTopLeftRadius: theme.effects.roundedCorner6,
      borderTopRightRadius: theme.effects.roundedCorner6,
    },
    ':last-child': {
      borderBottomLeftRadius: theme.effects.roundedCorner6,
      borderBottomRightRadius: theme.effects.roundedCorner6,
    },
  },
});
